<template>
    <div class="sa-con-set">
      <div class="sa-tabs sa-btn-tabs">
        <a
          v-on:click="tabSelection='smsSet'"
          @click="smsSetting()"
          v-bind:class="[ tabSelection === 'smsSet' ? 'active' : '' ]"
        >SMS Settings<i class="icon-right-arrow  tab-icon sa-h-sm-up"></i></a>
        <a
          v-on:click="tabSelection='emailSet'"
          @click="emailSetting()"
          v-bind:class="[ tabSelection === 'emailSet' ? 'active' : '' ]"
        >Email Settings<i class="icon-right-arrow tab-icon sa-h-sm-up"></i></a>
      </div>
      <div class="sa-tab-cont" :tabSelection="tabSelection">
        <div v-if="tabSelection === 'smsSet'">
          <div class="sa-sms-loading" v-if="loading"><img src="../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-left" /></div>
          <template v-else>
            <div class="sa-mb20" v-for="(i, index) in smsdetails.General" :key="i.TEXT">
              <input type="checkbox" :id="i.TEXT" v-model="i.SETTING" @change="editNotifcations(i)" :name="i.TEXT"/>
              <label :for="i.TEXT">{{i.TEXT}}</label>
            </div>
            <div class="sa-mb30 sa-mt30 sa-blue-text sa-text">
              <strong>Appointment reminder</strong>
            </div>
            <div class="sa-mb20" v-for="(i, index) in smsdetails.Reminder" :key="i.NOTIF_ID">
              <input type="checkbox" :id="i.NOTIF_ID" v-model="i.SETTING" @change="editNotifcations(i)" :name="i.NOTIF_ID"/>
              <label :for="i.NOTIF_ID">{{i.TEXT}}</label>
            </div>
          </template>
        </div>
        <div v-if="tabSelection === 'emailSet'">
          <div class="sa-sms-loading" v-if="loading"><img src="../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-left" /></div>
          <template v-else>
            <div class="sa-mb20" v-for="(i, index) in emaildetails.General" :key="i.NOTIF_ID">
              <input type="checkbox" :id="i.NOTIF_ID" v-model="i.SETTING" @change="editNotifcations(i)" :name="i.NOTIF_ID"/>
              <label :for="i.NOTIF_ID">{{i.TEXT}}</label>
            </div>
            <div class="sa-mb30 sa-mt30 sa-blue-text sa-text">
              <strong>Appointment reminder</strong>
            </div>
            <div class="sa-mb20" v-for="(i, index) in emaildetails.Reminder" :key="i.NOTIF_ID">
              <input type="checkbox" :id="i.NOTIF_ID" v-model="i.SETTING" @change="editNotifcations(i)" :name="i.NOTIF_ID"/>
              <label :for="i.NOTIF_ID">{{i.TEXT}}</label>
            </div>
          </template>
        </div>
        <div class="sa-dialog-white" v-if="loader">
          <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
        </div>
      </div>
      <div class="sa-text-right">
        <button class="sa-btn sa-btn-primary sa-blue-btn sa-btn-large" @click="editSetting()">
          Save
        </button>
      </div>
    </div>
</template>
<script>
import { pro_url } from "../../../config/endpoints";
import _ from "lodash";
export default {
  data() {
    return {
      tabSelection: "smsSet",
      editNotificationReq: [],
      smsdetails: {},
      emaildetails: {},
      loading: false,
      loader: false
    };
  },
  methods: {
    editNotifcations(obj) {
      _.remove(this.editNotificationReq, e => {
          return e.NOTIF_ID == obj.NOTIF_ID;
        });
      this.editNotificationReq.push({"NOTIF_ID": obj.NOTIF_ID, "SETTING": obj.SETTING})
    },
    smsSetting() {
      let _self = this;
      _self.loading = true;
      let res = _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/notifSettings/SMS`,
          body: {}
        })
        .then(response => {
          if (response.status === 1000) {
            _self.smsdetails = response.data;
          }
          _self.loading = false;
        });
    },
    emailSetting() {
      let _self = this;
      _self.loading = true;
      let res = _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/notifSettings/EMAIL`,
          body: {}
        })
        .then(response => {
          if (response.status === 1000) {
            _self.emaildetails = response.data;
          }
          _self.loading = false;
        });
    },
    editSetting() {
      let _self = this;
      _self.loader = true;
      /* for (var i = 0; i < _self.smsdetails.General; i++) {
        data.push({
          NOTIF_ID: _self.smsdetails.General[i].NOTIF_ID,
          SETTING: _self.smsdetails.General[i].SETTING
        });
      }
      for (var i = 0; i < _self.smsdetails.Reminder.length; i++) {
        data.push({
          NOTIF_ID: _self.smsdetails.Reminder[i].NOTIF_ID,
          SETTING: _self.smsdetails.Reminder[i].SETTING
        });
      }
      for (var i = 0; i < _self.emaildetails.General.length; i++) {
        data.push({
          NOTIF_ID: _self.emaildetails.General[i].NOTIF_ID,
          SETTING: _self.emaildetails.General[i].SETTING
        });
      }
      for (var i = 0; i < _self.emaildetails.Reminder.length; i++) {
        data.push({
          NOTIF_ID: _self.emaildetails.Reminder[i].NOTIF_ID,
          SETTING: _self.emaildetails.Reminder[i].SETTING
        });
      } */

      let res = _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/editNotifSettings`,
          body: {
            data: _self.editNotificationReq
          }
        })
        .then(response => {
          if (response.status === 1000) {
              _self.$store.dispatch('SET_ALERTMESSAGE', {msg: response.message, class: 'sa-a-success'})
          } else {
              _self.$store.dispatch('SET_ALERTMESSAGE', {msg: response.message, class: 'sa-a-danger'})
          }
          _self.loader = false;
        });
    }
  },
  created() {
    let _self = this;
    _self.smsSetting();
  }
};
</script>
